import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import KollabCommentStream from './KollabCommentStream';
import type {
  KollabCommentStreamProps,
  KollabCommentStreamAPI,
  KollabCommentStreamHandle,
} from './types';

declare global {
  interface Window {
    mountKollabCommentStream: (
      containerId: string,
      props: KollabCommentStreamProps,
    ) => KollabCommentStreamHandle;
  }
}

window.mountKollabCommentStream = function mountKollabCommentStream(
  containerId: string,
  props: KollabCommentStreamProps,
): KollabCommentStreamHandle {
  const container = document.getElementById(containerId);
  if (!container) {
    console.error('KollabCommentStream: container not found:', containerId);
    return {
      type: 'comment-stream',
      unmount: () => {},
      get api() { return null; },
    };
  }

  const apiRef = createRef<KollabCommentStreamAPI>();
  const root = createRoot(container);
  root.render(React.createElement(KollabCommentStream, { ...props, ref: apiRef }));

  return {
    type: 'comment-stream',
    unmount: () => root.unmount(),
    get api() { return apiRef.current; },
  };
};

export type {
  KollabCommentStreamProps,
  KollabCommentStreamAPI,
  KollabCommentStreamHandle,
};
